const COLORS = [
    '#ff4d4f', '#ff7875', '#ffa940', '#ffc53d',
    '#ffd666', '#73d13d', '#36cfc9', '#40a9ff',
    '#597ef7', '#9254de', '#f759ab', '#ff85c0',
];

function randomBetween(min, max) {
    return min + Math.random() * (max - min);
}

function pickColor() {
    return COLORS[Math.floor(Math.random() * COLORS.length)];
}

class Particle {
    constructor(x, y, vx, vy, color, size, decay, gravity) {
        this.x = x;
        this.y = y;
        this.vx = vx;
        this.vy = vy;
        this.color = color;
        this.size = size;
        this.decay = decay;
        this.gravity = gravity;
        this.alpha = 1;
        this.trail = [];
    }

    update() {
        this.trail.push({ x: this.x, y: this.y, alpha: this.alpha * 0.45 });
        if (this.trail.length > 4) {
            this.trail.shift();
        }

        this.vx *= 0.985;
        this.vy *= 0.985;
        this.vy += this.gravity;
        this.x += this.vx;
        this.y += this.vy;
        this.alpha -= this.decay;
    }

    draw(ctx) {
        this.trail.forEach((point) => {
            ctx.beginPath();
            ctx.globalAlpha = point.alpha;
            ctx.fillStyle = this.color;
            ctx.arc(point.x, point.y, this.size * 0.55, 0, Math.PI * 2);
            ctx.fill();
        });

        ctx.globalAlpha = Math.max(this.alpha, 0);
        ctx.beginPath();
        ctx.fillStyle = this.color;
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.globalAlpha = 1;
    }

    get alive() {
        return this.alpha > 0;
    }
}

class Rocket {
    constructor(x, targetY, color) {
        this.x = x;
        this.y = targetY + randomBetween(80, 160);
        this.targetY = targetY;
        this.color = color;
        this.speed = randomBetween(7, 11);
        this.trail = [];
        this.done = false;
    }

    update() {
        this.trail.push({ x: this.x, y: this.y });
        if (this.trail.length > 8) {
            this.trail.shift();
        }
        this.y -= this.speed;
        if (this.y <= this.targetY) {
            this.done = true;
        }
    }

    draw(ctx) {
        this.trail.forEach((point, index) => {
            ctx.globalAlpha = (index + 1) / this.trail.length;
            ctx.beginPath();
            ctx.fillStyle = this.color;
            ctx.arc(point.x, point.y, 2, 0, Math.PI * 2);
            ctx.fill();
        });
        ctx.globalAlpha = 1;
        ctx.beginPath();
        ctx.fillStyle = '#fff';
        ctx.arc(this.x, this.y, 3, 0, Math.PI * 2);
        ctx.fill();
    }
}

class Confetti {
    constructor(x, y, width) {
        this.x = x;
        this.y = y;
        this.width = randomBetween(4, 8);
        this.height = randomBetween(8, 14);
        this.color = pickColor();
        this.vx = randomBetween(-2.5, 2.5);
        this.vy = randomBetween(-6, -2);
        this.rotation = randomBetween(0, Math.PI * 2);
        this.spin = randomBetween(-0.18, 0.18);
        this.gravity = randomBetween(0.08, 0.16);
        this.alpha = 1;
        this.maxX = width;
    }

    update() {
        this.vx *= 0.99;
        this.vy += this.gravity;
        this.x += this.vx;
        this.y += this.vy;
        this.rotation += this.spin;
        if (this.y > 0) {
            this.alpha -= 0.008;
        }
    }

    draw(ctx) {
        ctx.save();
        ctx.globalAlpha = Math.max(this.alpha, 0);
        ctx.translate(this.x, this.y);
        ctx.rotate(this.rotation);
        ctx.fillStyle = this.color;
        ctx.fillRect(-this.width / 2, -this.height / 2, this.width, this.height);
        ctx.restore();
        ctx.globalAlpha = 1;
    }

    get alive() {
        return this.alpha > 0 && this.y < this.maxX + 40;
    }
}

export default class FireworksEngine {
    constructor(canvas) {
        this.canvas = canvas;
        this.ctx = canvas.getContext('2d');
        this.width = 0;
        this.height = 0;
        this.particles = [];
        this.rockets = [];
        this.confetti = [];
        this.rafId = 0;
        this.running = false;
        this.lastBurst = 0;
        this.burstInterval = 420;
        this.endAt = 0;
    }

    resize() {
        const rect = this.canvas.getBoundingClientRect();
        const ratio = window.devicePixelRatio || 1;
        this.width = rect.width;
        this.height = rect.height;
        this.canvas.width = Math.floor(rect.width * ratio);
        this.canvas.height = Math.floor(rect.height * ratio);
        this.ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    }

    burst(x, y, color) {
        const count = 36 + Math.floor(Math.random() * 18);
        for (let i = 0; i < count; i += 1) {
            const angle = (Math.PI * 2 * i) / count + randomBetween(-0.08, 0.08);
            const speed = randomBetween(2.5, 7.5);
            this.particles.push(new Particle(
                x,
                y,
                Math.cos(angle) * speed,
                Math.sin(angle) * speed,
                color || pickColor(),
                randomBetween(1.6, 2.8),
                randomBetween(0.012, 0.022),
                0.045,
            ));
        }
    }

    launchRocket() {
        const x = randomBetween(this.width * 0.15, this.width * 0.85);
        const targetY = randomBetween(this.height * 0.18, this.height * 0.42);
        const color = pickColor();
        this.rockets.push(new Rocket(x, targetY, color));
    }

    spawnConfetti(count = 16) {
        for (let i = 0; i < count; i += 1) {
            this.confetti.push(new Confetti(
                randomBetween(0, this.width),
                randomBetween(-20, this.height * 0.2),
                this.height,
            ));
        }
    }

    start(duration = 4500) {
        this.stop(false);
        this.resize();
        this.running = true;
        this.endAt = Date.now() + duration;
        this.lastBurst = 0;
        this.spawnConfetti(28);
        this.loop();
    }

    loop() {
        if (!this.running) {
            return;
        }

        const now = Date.now();
        this.ctx.clearRect(0, 0, this.width, this.height);

        if (now - this.lastBurst >= this.burstInterval) {
            this.launchRocket();
            if (Math.random() > 0.35) {
                this.launchRocket();
            }
            this.lastBurst = now;
        }

        this.rockets = this.rockets.filter((rocket) => {
            rocket.update();
            rocket.draw(this.ctx);
            if (rocket.done) {
                this.burst(rocket.x, rocket.y, rocket.color);
                return false;
            }
            return true;
        });

        this.particles = this.particles.filter((particle) => {
            particle.update();
            particle.draw(this.ctx);
            return particle.alive;
        });

        this.confetti = this.confetti.filter((piece) => {
            piece.update();
            piece.draw(this.ctx);
            return piece.alive;
        });

        if (Math.random() > 0.72) {
            this.spawnConfetti(4);
        }

        if (now >= this.endAt && !this.particles.length && !this.rockets.length && !this.confetti.length) {
            this.stop(false);
            return;
        }

        this.rafId = window.requestAnimationFrame(() => this.loop());
    }

    stop(clearCanvas = true) {
        this.running = false;
        if (this.rafId) {
            window.cancelAnimationFrame(this.rafId);
            this.rafId = 0;
        }
        this.particles = [];
        this.rockets = [];
        this.confetti = [];
        if (clearCanvas && this.ctx) {
            this.ctx.clearRect(0, 0, this.width, this.height);
        }
    }
}
